var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dp-solutions", attrs: { name: "dp-user-solutions" } },
    [
      _c("div", { staticClass: "dp-solutions-container clearfix" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "solv-disputes hide col col-right col-last clearfix" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "discsol-list row" },
            _vm._l(_vm.solutions, function(ref) {
              var heading = ref.heading
              var solution = ref.solution
              return _c(
                "div",
                { key: solution, staticClass: "discsol-post-wrapper row" },
                [
                  _c("div", { staticClass: "discsol-post solution row" }, [
                    _c("div", { staticClass: "solution-main row" }, [
                      _c(
                        "div",
                        { staticClass: "solution-header with-actions row" },
                        [
                          _vm._m(1, true),
                          _vm._v(" "),
                          _c("div", { staticClass: "text" }, [
                            _c("div", [
                              _c(
                                "span",
                                { staticClass: "btn-profile mini-profile" },
                                [_vm._v(_vm._s(heading))]
                              )
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "comment-content solution-content row" },
                        [
                          _c(
                            "div",
                            { staticClass: "hide-on-edit hide-on-delete row" },
                            [
                              _c("div", { staticClass: "text" }, [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.processedHtml(solution)
                                    )
                                  }
                                })
                              ])
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                ]
              )
            }),
            0
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "discsol-list-header row" }, [
      _c("h2", [_vm._v("Explanation")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "avatar mini-profile" }, [
      _c("img", {
        attrs: {
          src:
            "https://ds055uzetaobb.cloudfront.net/site_media/images/default-avatar-globe.png",
          width: "45",
          height: "45"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }